import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

/**
 * A flat side-panel section: quiet heading, optional icon actions, rows below.
 * Shared by the home panel and the discovery panel so both sides read alike.
 */
export function PanelSection({ title, action, children, className }: { title: string; action?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={cn("py-3", className)}>
      <div className="flex h-8 items-center justify-between px-4">
        <h2 className="text-xs font-semibold text-fg-3">{title}</h2>
        <div className="-mr-1.5 flex items-center">{action}</div>
      </div>
      <div className="mt-1 px-2">{children}</div>
    </section>
  );
}

/** Heading for a section inside the main column, matching the panel style. */
export function ColumnSectionTitle({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex h-10 items-end justify-between px-4 pb-1.5">
      <h2 className="text-xs font-semibold text-fg-3">{children}</h2>
      {action}
    </div>
  );
}
